module.exports = __webpack_public_path__ + "static/media/cctv.487e45b7.svg";